import React from 'react';
import { Button } from 'primereact/button';

import { phone } from '../Utils/phone';

/**
 * Footer mobile-first: blocos empilhados em uma coluna única,
 * com tipografia e gaps proporcionais a viewport ≤767px.
 *
 * Props (compatíveis com Layouts/Mobile.js):
 *  - setTermsModal, setPrivacyModal, setDataModal
 */
const MobileFooter = ({ setTermsModal, setPrivacyModal, setDataModal }) => {
    return (
        <div className="wrapper__footer mobile-revamp-footer">
            <div className="mobile-revamp-footer__container">
                <section className="mobile-revamp-footer__block">
                    <h3>Quem é a SMI</h3>
                    <p>
                        A SMI é o nome comercial da SM Travel LTDA, agência de desenvolvimento de vendas
                        e marketing dedicada ao mercado do turismo. Estando há mais de quatro décadas no
                        mercado e dotada de impecável situação financeira a SMI atende marcas globais tais
                        como a Enterprise Mobility, proprietária da Alamo, Enteprise e National, Design
                        Hotels, San Francisco Travel e The Costa Rica Collection. A SMI também possui
                        marcas próprias tais como a OTC - Online Travel Concierge, plataforma exclusiva
                        de vendas de passeios, atrações e traslados.
                    </p>
                </section>

                <section className="mobile-revamp-footer__block">
                    <h3>Informações Legais</h3>
                    <Button
                        text label="Termos e condições de uso"
                        className="mobile-revamp-footer__link"
                        onClick={() => setTermsModal(true)}
                    />
                    <Button
                        text label="Política de privacidade"
                        className="mobile-revamp-footer__link"
                        onClick={() => setPrivacyModal(true)}
                    />
                    <Button
                        text label="Uso de dados"
                        className="mobile-revamp-footer__link"
                        onClick={() => setDataModal(true)}
                    />
                </section>

                <section className="mobile-revamp-footer__block">
                    <h3>Contatos</h3>
                    <p>
                        Endereço: R. Praia de botafogo 440, Sala 702
                        <br />Rio de Janeiro, RJ, CEP 22250-908
                    </p>
                    <p>
                        Whatsapp:&nbsp;
                        <a href={`tel:${phone.withDDI}`} className="mobile-revamp-footer__inline-link">
                            {phone.displayBR}
                        </a>
                    </p>
                    <p>
                        Telefone:&nbsp;
                        <a href={`tel:${phone.telLocal}`} className="mobile-revamp-footer__inline-link">
                            {phone.localOnly}
                        </a>
                    </p>
                </section>

                <div className="mobile-revamp-footer__copyright">
                    <span>&copy;2025 Todos os direitos reservados a SMTRAVEL LTDA</span>
                    <span>
                        Made by{' '}
                        <a
                            href="http://smi.net.br/"
                            target="_blank"
                            rel="noreferrer"
                            className="mobile-revamp-footer__inline-link"
                        >
                            SMI
                        </a>
                    </span>
                </div>
            </div>
        </div>
    );
};

export default MobileFooter;
